// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__mUVfS","options":"AnswerScale_options__3Q8ML","selected":"AnswerScale_selected__2lFb1"};